import { render, staticRenderFns } from "./AccommodationRoomsEdit.vue?vue&type=template&id=2b10e076&scoped=true"
import script from "./AccommodationRoomsEdit.vue?vue&type=script&lang=js"
export * from "./AccommodationRoomsEdit.vue?vue&type=script&lang=js"
import style0 from "./AccommodationRoomsEdit.vue?vue&type=style&index=0&id=2b10e076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b10e076",
  null
  
)

export default component.exports